import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("hero");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const pos = window.scrollY + 120;
      let current = "hero";
      for (const link of navLinks) {
        const el = document.getElementById(link.id);
        if (el && el.offsetTop <= pos) current = link.id;
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id: string) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] items-center justify-between px-4 md:px-6">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            scrollToId("hero");
          }}
          className="flex items-center gap-2.5"
          aria-label="爆料吧 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-white">
            <i className="ri-fire-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-serifsc text-2xl font-bold tracking-tight text-foreground-950">
            爆料<span className="text-primary-500">吧</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleNav(link.id);
              }}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                active === link.id
                  ? "bg-primary-500 text-white"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            onClick={(e) => {
              e.preventDefault();
              handleNav("submit");
            }}
            className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500"
          >
            <i className="ri-send-plane-fill text-base" aria-hidden="true"></i>
            投稿入口
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-950 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(link.id);
                }}
                className={`rounded-lg px-4 py-3 text-sm font-medium ${
                  active === link.id
                    ? "bg-primary-500 text-white"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={(e) => {
                e.preventDefault();
                handleNav("submit");
              }}
              className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-foreground-950 px-5 py-3 text-sm font-semibold text-background-50"
            >
              <i className="ri-send-plane-fill text-base" aria-hidden="true"></i>
              投稿入口
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}